import { takeEvery, fork, put, all, call } from "redux-saga/effects";

import {
  apiError,
  getVersions,
  versionsListSuccessful,
  versionsAddSuccessful,
  isModelVisible,
} from "./versionsSlice";

// Auth Related Methods

import {
  postAdd,
  getParamsList,
  postEdit,
  postDelete,
} from "../../../helpers/Helper";

import { Modal } from "antd";
import {
  RiCheckboxCircleLine,
  RiAlertLine,
  RiInformationLine,
} from "react-icons/ri";
import versionData from "./versionData.json"

function* getVersion({ payload }) {
  var data = payload;
  var params = {};

  for (const k in data) {
    if (Object.hasOwnProperty.call(data, k)) {
      if (k === "currentSort" || k === "sortOrder") {
        params.ordering = data.sortOrder + data.currentSort;
      } else {
        if (data[k] != "" && k != null && k != "no_of_pages") {
          params[k] = data[k];
        }
      }
    }
  }
  try {
    const VersionData = versionData
    // const response = yield call(getParamsList, "/masters/versions/", params);
    yield put(versionsListSuccessful(VersionData));
  } catch (error) {
    yield put(apiError(error));
  }
}

function* AddVersions({ payload }) {
  try {
    if (payload.id == 0) {
      const response = yield call(postAdd, "/masters/versions/", payload);
      if (response.status === 201) {
        Modal.success({
          icon: (
            <span className="remix-icon">
              <RiCheckboxCircleLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">success</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Your Version Add Successfully.!
              </p>
            </div>
          ),
        });
        yield put(getVersions({ page: 1, search: "", page_size: 10 }));
        yield put(isModelVisible(false));
      } else {
        Modal.error({
          icon: (
            <span className="remix-icon">
              <RiAlertLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Sorry! Unable to added Version. Please try again!
              </p>
            </div>
          ),
        });
      }
      yield put(versionsAddSuccessful(null));

    } else {
      const response = yield call(
        postEdit,
        "/masters/versions/" + payload.id,
        payload
      );
      if (response.status === 200) {
        Modal.success({
          icon: (
            <span className="remix-icon">
              <RiCheckboxCircleLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">success</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Your Version Edited Successfully.!
              </p>
            </div>
          ),
        });
        yield put(getVersions({ page: 1, search: "", page_size: 10 }));
        yield put(isModelVisible(false));
      } else {
        Modal.error({
          icon: (
            <span className="remix-icon">
              <RiAlertLine />
            </span>
          ),
          title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
          content: (
            <div>
              <p className="hp-p1-body hp-text-color-black-80">
                Sorry! Unable to edit Version. Please try again!
              </p>
            </div>
          ),
        });
      }
      yield put(versionsAddSuccessful(null));
    }

  } catch (error) {
    Modal.error({
      icon: (
        <span className="remix-icon">
          <RiAlertLine />
        </span>
      ),

      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: (
        <div>
          <p className="hp-p1-body hp-text-color-black-80">
            Sorry! Getting from server side issue!
          </p>
        </div>
      ),
    });
    yield put(apiError(error));
  }
}
function* DeleteVersions({ payload }) {
  var areaID = payload;
  try {
    const response = yield call(postDelete, "/masters/versions/" + areaID);

    if (response.status === 204) {
      Modal.success({
        icon: (
          <span className="remix-icon">
            <RiCheckboxCircleLine />
          </span>
        ),
        title: <h5 className="hp-mb-0 hp-font-weight-500">success</h5>,
        content: (
          <div>
            <p className="hp-p1-body hp-text-color-black-80">
              Your Version has been deleted!
            </p>
          </div>
        ),
      });
      yield put(getVersions({ page: 1, search: "", page_size: 10 }));
    } else {
      Modal.error({
        icon: (
          <span className="remix-icon">
            <RiAlertLine />
          </span>
        ),
        title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
        content: (
          <div>
            <p className="hp-p1-body hp-text-color-black-80">
              Sorry! Your Version has been not deleted!
            </p>
          </div>
        ),
      });
    }
  } catch (error) {
    Modal.error({
      icon: (
        <span className="remix-icon">
          <RiAlertLine />
        </span>
      ),

      title: <h5 className="hp-mb-0 hp-font-weight-500">Error</h5>,
      content: (
        <div>
          <p className="hp-p1-body hp-text-color-black-80">
            Sorry! Getting from server side issue!
          </p>
        </div>
      ),
    });

    yield put(apiError(error));
  }
}

function* watchgetVersions() {
  yield takeEvery("versions/getVersions", getVersion);
}

export function* watchVersionsAdd() {
  yield takeEvery("versions/versionsAdd", AddVersions);
}

export function* watchVersionsDelete() {
  yield takeEvery("versions/versionsDelete", DeleteVersions);
}

function* VersionsSaga() {
  yield all([fork(watchgetVersions), fork(watchVersionsAdd), fork(watchVersionsDelete)]);
}

export default VersionsSaga;
